/* eslint-disable import/prefer-default-export */
import { graphql } from 'graphql-schema';

export const SPORTS_QUERY = graphql(`
  query Sports($where: sports_bool_exp!) {
    sports(where: $where) {
      _id
      name
    }
  }
`);
